import React, { useEffect, useRef, useState } from "react";

export default function LongTextCell({ value, readOnly, onCommit }) {
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState(value ?? "");
  const ref = useRef(null);

  useEffect(() => { setDraft(value ?? ""); }, [value]);
  useEffect(() => { if (editing) ref.current?.focus(); }, [editing]);

  const commit = () => {
    setEditing(false);
    if ((draft || "") !== (value || "")) onCommit(draft === "" ? null : draft);
  };

  if (editing && !readOnly) {
    return (
      <textarea
        ref={ref}
        className="cell-input long-text-input"
        rows={3}
        value={draft ?? ""}
        onChange={(e) => setDraft(e.target.value)}
        onBlur={commit}
        onKeyDown={(e) => {
          if (e.key === "Escape") {
            setDraft(value ?? "");
            setEditing(false);
          }
        }}
      />
    );
  }

  const preview = (value || "").replace(/\s+/g, " ").trim();
  return (
    <div
      className={`cell-display long-text ${readOnly ? "read-only" : ""}`}
      onClick={() => !readOnly && setEditing(true)}
      title={value || ""}
    >
      {preview ? <span className="truncate">{preview}</span> : <span className="placeholder">—</span>}
    </div>
  );
}
